import React from 'react';

export function AlmondIcon({ size = 24, className = '' }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} className={className} aria-hidden="true">
      <path
        d="M12 2.6C9.4 4 7 7.5 7 12.2 7 17 9.2 21 12 21s5-4 5-8.8C17 7.5 14.6 4 12 2.6z"
        fill="currentColor"
      />
      <g stroke="#2C3A28" strokeWidth="0.8" strokeLinecap="round" fill="none" opacity="0.4">
        <path d="M12 6c-1 3.8-1.3 8.6-.7 12.6" />
        <path d="M13.7 7.2c-.4 3.4-.4 7.6.1 11.1" />
        <path d="M10.2 7.4c-.6 3.2-.6 7 -.1 10.4" />
      </g>
    </svg>
  );
}

export default AlmondIcon;
